module.exports = __webpack_public_path__ + "static/media/jigger.bc96c892.png";